// Package Imports
import { queryOptions, useMutation } from '@tanstack/react-query'

// Core Imports
import type { TResponseError } from '@/core/types/axios'
import type { TMutation } from '@/core/types/react-query'

// Module Imports
import {
  createRole,
  deleteRole,
  editRole,
  getAllPermissions,
  getRoleDetail,
  getRoleList,
} from '@/modules/role/role.service'
import type {
  TCreateRoleRequest,
  TEditRoleRequest,
  TRole,
} from '@/modules/role/role.types'

export const roleListQueryOptions = () =>
  queryOptions({
    queryKey: ['roleList'],
    queryFn: getRoleList,
  })

export const roleDetailQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ['roleDetail', id],
    queryFn: () => getRoleDetail(id),
    staleTime: 0,
    enabled: Boolean(id),
  })

export const allPermissionsQueryOptions = () =>
  queryOptions({
    queryKey: ['allPermissions'],
    queryFn: getAllPermissions,
  })

export function useCreateRole({
  onSuccess,
  onError,
}: TMutation<TRole, TResponseError, TCreateRoleRequest>) {
  return useMutation<TRole, TResponseError, TCreateRoleRequest>({
    mutationFn: createRole,
    onSuccess,
    onError,
  })
}

export function useEditRole({
  onSuccess,
  onError,
}: TMutation<TRole, TResponseError, TEditRoleRequest>) {
  return useMutation<TRole, TResponseError, TEditRoleRequest>({
    mutationFn: editRole,
    onSuccess,
    onError,
  })
}

export function useDeleteRole({
  onSuccess,
  onError,
}: TMutation<string, TResponseError, string>) {
  return useMutation<string, TResponseError, string>({
    mutationFn: deleteRole,
    onSuccess,
    onError,
  })
}
